import { Box } from '@mui/material';
import { MdOutlineNotificationsActive } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { Item, WsColors } from 'wisestep-base';

import SettingsIndex from '../../../components/SettingsIndex';

const UserProfileIndex = ({ getSelectedOption }) => (
  <Box p={3}>
    <Item sx={{ backgroundColor: WsColors.White }}>
      <SettingsIndex
        options={[
          {
            label: 'Notifications',
            icon: <MdOutlineNotificationsActive size={24} />,
          },
          {
            label: 'Password',
            icon: <RiLockPasswordLine size={24} />,
          },
        ]}
        getSelectedOption={getSelectedOption}
      />
    </Item>
  </Box>
);

export default UserProfileIndex;
